import React, { useState } from 'react';

const ZIPCodeInput = ({ 
  value = '', 
  onChange, 
  label = '邮政编码', 
  placeholder = '12345 或 12345-6789',
  required = false,
  className = '',
  maxLength = 10,
  disabled = false
}) => {
  const [error, setError] = useState('');

  // 验证邮政编码格式
  const validateZIPCode = (zipCode) => {
    if (!zipCode) return '';
    
    // 基本格式：5位数字
    const basicFormat = /^\d{5}$/;
    // 扩展格式：5位数字-4位数字
    const extendedFormat = /^\d{5}-\d{4}$/;
    
    if (basicFormat.test(zipCode) || extendedFormat.test(zipCode)) {
      return '';
    }
    
    return '请输入有效的美国邮政编码格式（如：12345 或 12345-6789）';
  };

  // 处理输入变化
  const handleChange = (e) => {
    let inputValue = e.target.value;
    
    // 只允许数字和连字符
    inputValue = inputValue.replace(/[^\d-]/g, '');
    
    // 限制连字符的使用
    const dashCount = (inputValue.match(/-/g) || []).length;
    if (dashCount > 1) {
      inputValue = inputValue.replace(/-/g, (match, index) => {
        return index === 5 ? '-' : '';
      });
    }
    
    // 限制连字符位置（只能在第6位）
    if (inputValue.length > 5 && !inputValue.includes('-')) {
      inputValue = inputValue.slice(0, 5) + '-' + inputValue.slice(5);
    }
    
    // 限制总长度
    if (inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
    }
    
    // 验证格式
    const validationError = validateZIPCode(inputValue);
    setError(validationError);
    
    // 调用父组件的onChange
    onChange(inputValue);
  };

  // 处理失去焦点时的验证
  const handleBlur = () => {
    if (value && !error) {
      const validationError = validateZIPCode(value);
      setError(validationError);
    }
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      
      <div className="relative">
        <input
          type="text"
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          className={`w-full h-12 px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 ${
            error 
              ? 'border-red-300 bg-red-50 focus:ring-red-500' 
              : 'border-gray-300 bg-gradient-to-r from-white to-blue-50 shadow-sm hover:shadow-md'
          } ${disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : ''}`}
        />
        
        {/* 格式提示 */}
        {!error && value && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <div className="text-green-500">
              {value.length === 5 ? '✓' : value.length === 10 ? '✓' : ''}
            </div>
          </div>
        )}
      </div>
      
      {/* 错误信息 */}
      {error && (
        <p className="mt-1 text-sm text-red-600 flex items-center">
          <span className="w-4 h-4 mr-1">⚠️</span>
          {error}
        </p>
      )}
      
      {/* 帮助信息 */}
      {!error && !value && (
        <p className="mt-1 text-xs text-gray-500">
          格式：12345 或 12345-6789
        </p>
      )}
    </div>
  );
};

export default ZIPCodeInput; 